module.exports = __webpack_public_path__ + "static/media/gift-outline-icon.f1b7f5f6.svg";